import axios from 'axios'
// Vue.prototype.$ajax = Axios;
import qs from 'qs'
import Bus from '@/utils/Bus'

var instance = axios.create({
  baseURL: '',
  timeout: 13000 * 10,
  headers: { 'X-Custom-Header': 'foobar'   }
})

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (
      config.method.toLowerCase() === 'post' &&
      config.data &&
      config.data.formEncode
    ) {
      config.data = qs.stringify(config.data)
    }
    if (config.headers && window.wx_code) { //weixin code
      console.log(window.wx_code,"===========>window.wx_code")
      config.headers = {
        ...config.headers,
        code: window.wx_code
      }
    }


    Bus.$emit('show-loading')
    return config
  },
  function (error) {
    // Do something with request error
    Bus.$emit('show-loading')
    return Promise.reject(error)
  }
)
const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
}
const errorHandler = error => {
  const { response = {} } = error
  const errortext = codeMessage[response.status] || response.statusText
  const { status, url } = response
  if (status == 401) {
    window.toast({
      txt: '未登录或登录已过期，请重新登录。',
      type: 'txt'
    }).show()
    return
  }
  // if (error.response) {
  //   // 请求已发出，但服务器响应的状态码不在 2xx 范围内
  //   console.log(error.response.data);
  //   console.log(error.response.status);
  //   console.log(error.response.headers);
  // } else {
  //   // Something happened in setting up the request that triggered an Error
  //   console.log('Error', error.message);
  // }
  // console.log(error.config);
  if (!status) {
    return
  }
  window.toast({
    txt: errortext || `服务异常，请稍后再试`,
    type: 'txt'
  }).show()
  // environment should not be used
  if (status === 403) {
    // router.push('/exception/403');
    return
  }
  if (status <= 504 && status >= 500) {
    // router.push('/exception/500');
    return
  }
  if (status >= 404 && status < 422) {
    // router.push('/exception/404');
  }
}
// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    // console.log('response -> ', response)
    Bus.$emit('hide-loading')
    let downUrl = response.config.url.split("?")
    if(response.config.url.indexOf('getJsJdkSign2') > -1){
      return response
    }
    const { code, msg ,returnCode ,returnMsg } = response.data
    if (response.status !=200 && code != 200 && returnCode != "00" && returnCode != "01" && returnCode != "0000") {
      console.log(response, '1111')
      return Promise.reject(response)
    }
    return response
  },
  function (error) {
    // Do something with response error
    Bus.$emit('hide-loading')
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      errorHandler(error)
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message)
    }
    console.log(error.config)
    // window.router.push('/login');
    return Promise.reject(error)
  }
)

let api = {}

/* 上传风险告知函 */
api.ocrOfficialSeal = function (policyId, data) {
  return instance.post(`/api_risk_cps/riskReport/ocrOfficialSeal?policyId=${policyId}`, data,
    {
      headers: {
      'Content-Type': 'multipart/form-data',
      }
    }
  )
}

/* 下载风险告知函模板 */
api.createRiskReportPdf = function (policyId) {
  return instance.get(`/api_risk_cps/riskReport/createRiskReportPdf?policyId=${policyId}`, {responseType: 'blob'})
}

export default api
